import { createSlice } from '@reduxjs/toolkit';
import { TasksStore } from './store';
export const tasksSlice = createSlice({
    name: '@@TASKS',
    initialState: TasksStore.empty(),
    reducers: (create)=>({
            empty: create.reducer(()=>TasksStore.empty()),
            add: create.reducer((state, { payload: task })=>TasksStore.add(task)(state)),
            creating: create.reducer((state, { payload: [task, id] })=>TasksStore.creating(task, id)(state)),
            created: create.reducer((state, { payload: [task, id] })=>TasksStore.created(task, id)(state)),
            failed: create.reducer((state, { payload: id })=>TasksStore.failed(id)(state)),
            loadingProjectTasks: create.reducer((state, { payload: projectId })=>TasksStore.loadingProjectTasks(projectId)(state)),
            loadedProjectTasks: create.reducer((state, { payload: [projectId, tasks] })=>TasksStore.loadedProjectTasks(projectId, tasks)(state)),
            loadedAllTasks: create.reducer((state, { payload: tasks })=>TasksStore.loadedAllTasks(tasks)(state)),
            updating: create.reducer((state, { payload: tasks })=>TasksStore.updating(tasks)(state)),
            updated: create.reducer((state, { payload: tasks })=>TasksStore.updated(tasks)(state)),
            revert: create.reducer((state, { payload: taskIds })=>TasksStore.revert(taskIds)(state)),
            deleting: create.reducer((state, { payload: tasks })=>TasksStore.deleting(tasks)(state)),
            deleted: create.reducer((state, { payload: tasks })=>TasksStore.deleted(tasks.map((x)=>x.taskId))(state)),
            restored: create.reducer((state, { payload: tasks })=>TasksStore.restored(tasks.map((x)=>x.taskId))(state))
        })
});
